import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../services/userService";
import { toast } from "react-toastify";

// Async thunks for profile operations
export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await userService.updateProfile(userData);
      toast.success("Profile updated successfully");
      return response.success;
    } catch (error) {
      toast.error(error.message || "Failed to update profile");
      return rejectWithValue(error.message || "Failed to update profile");
    }
  }
);

export const updatePassword = createAsyncThunk(
  "profile/updatePassword",
  async (passwords, { rejectWithValue }) => {
    try {
      const response = await userService.updatePassword(passwords);
      toast.success("Password updated successfully");
      return response.success;
    } catch (error) {
      toast.error(error.message || "Failed to update password");
      return rejectWithValue(error.message || "Failed to update password");
    }
  }
);

// Initial state
const initialState = {
  loading: false,
  isUpdated: false,
  error: null,
};

// Profile slice
const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
    },
    resetUpdate: (state) => {
      state.isUpdated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Update Profile
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.isUpdated = false;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state) => {
        state.loading = false;
        state.isUpdated = true;
        state.error = null;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.isUpdated = false;
        state.error = action.payload;
      })
      // Update Password
      .addCase(updatePassword.pending, (state) => {
        state.loading = true;
        state.isUpdated = false;
        state.error = null;
      })
      .addCase(updatePassword.fulfilled, (state) => {
        state.loading = false;
        state.isUpdated = true;
        state.error = null;
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.loading = false;
        state.isUpdated = false;
        state.error = action.payload;
      });
  },
});

export const { clearErrors, resetUpdate } = profileSlice.actions;
export default profileSlice.reducer;

